import { useSelector } from 'react-redux';
import { MenuState } from '@/reducers/menu';

export default function useMenuFavoriteList() {
  const menuFavoriteList = useSelector((state: { menu: MenuState }) => state.menu.menuFavoriteList);

  return menuFavoriteList;
}
